import React from "react";
import { useTranslation } from 'react-i18next';

const Training = () => {
    const { t } = useTranslation();

    const trainingOptions = [
        {
            id: 1,
            title: "Review the reading materials provided by the OAA (available throughout the trimester)",
        },
        {
            id: 2,
            title: "Watch videos recorded by the instructors",
        },
        {
            id: 3,
            title: "Live sessions (seminars) with the professionals and academics offering valuable insights and practical experience",
        },
        {
            id: 4,
            title: "Submit essays upon completion of each topic (no more than 300 words)",
        },
        {
            id: 5,
            title: "Submit final essay (no more than 500 words)",
        },
        
    ];

    return (
        <div className="">
            <h2 className="font-semibold text-[24px]">{t('training.title')}</h2>
            <div className="flex flex-wrap justify-between pt-[30px] pb-[14px] bg-[#0A1F44] text-[#FFF] mt-[24px]">
                {trainingOptions.map((option) => (
                    <div
                        key={option.id}
                        className="w-full sm:w-full lg:w-[20%] px-4 sm:border-b-0 pb-3 border-b lg:border-r border-gray-300 last:border-r-0 last:border-b-0"
                    >
                        <h1 className="text-[56px] sm:text-[76px] font-bold">{option.id}</h1>
                        <h2 className="font-semibold pt-4 text-[20px]">
                            {option.title}
                        </h2>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Training;